<div class="dialog-container">
  <div class="dialog-header2">
    <div class="user-edit-icon">
      <img src="assets/images/health/icons/dtopico/Group 15.svg" class="add-icon" alt="User Icon" />
    </div>
    <div class="header-text">
      <h2 class="addmed">Add Manual Devices</h2>
    </div>
    <img class="close-button" (click)="onCancel()" src="assets/images/close-circle.svg">
    <!-- <button mat-icon-button (click)="onCancel()" class="close-button">
      <mat-icon>close</mat-icon>
    </button> -->
  </div>

  <div class="dialog-content" style="padding: 18px;">
    <form class="dialog-form">
      <h2 class="chosedev">Choose Devices</h2>
      <h4 class="maninp">Add Vitals to manually input readings</h4>

      <div class="vd-field">
        <label class="vd-label" id="ad-select-label">Select Devices</label>
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100 vd-select">
          <mat-select [(ngModel)]="selectedDevice" name="selectedDevice" placeholder="Select a device" aria-labelledby="ad-select-label">

            <!-- This part shows the selected value (icon + title) in the input box -->
            <mat-select-trigger>
              <i [class]="deviceIcon(selectedDevice?.systemId)" aria-hidden="true"></i>
              <span class="device-label"> {{ selectedDevice?.title }}</span>
            </mat-select-trigger>

            <!-- Dropdown options -->
            <mat-option *ngFor="let device of device_names" [value]="device">
              <span class="device-option">
                <i [class]="deviceIcon(device.systemId)" aria-hidden="true"></i>
                <span class="device-label">{{ device.title }}</span>
              </span>
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

    </form>
  </div>

  <div class="dialog-actions2">
    <button type="button" class="vd-btn vd-btn--secondary" (click)="onCancel()">Cancel</button>
    <button type="button" class="vd-btn vd-btn--primary" [disabled]="!selectedDevice" (click)="onSave()">Save</button>
  </div>
</div>